import React, { useState, useEffect } from "react";
import { Select, Spin, message } from "antd";
import api from "../services/api";

const { Option } = Select;

// ── ENDPOINT do novo dashboard ─────────────────────────────────────────
// O RAD Server remove o prefixo "Get" do nome do método e usa como verbo HTTP,
// então o método GetPesquisaDashboard é publicado em /ServerPrincipal/PesquisaDashboard.
const DASHBOARD_ENDPOINT = "/ServerPrincipal/PesquisaDashboard";

// ── Helper FireDAC ─────────────────────────────────────────────────────
const extractRows = (data) => {
  if (!data) return [];
  if (data.FDBS) {
    try {
      const tables = data.FDBS.Manager.TableList;
      if (tables?.length > 0 && tables[0].RowList)
        return tables[0].RowList.map((r) => r.Original);
    } catch (e) {}
  }
  if (data.Table && Array.isArray(data.Table)) return data.Table;
  if (Array.isArray(data)) return data;
  return [];
};

// ── Logos programas com cores exatas e gradientes ─────────────────────
const LOGOS_MAP = [
  // ── Nacionais ──────────────────────────────────────────────────────
  { keys: ["livelo"],                    bg: "#e8008b", letra: "LV"  },
  { keys: ["itaú pontos","itau pontos"], bg: "#d48c0c", letra: "IT"  },
  { keys: ["smiles"],                    bg: "#ff6600", letra: "S"   },
  { keys: ["azul fidelidade","azul"],    bg: "#003087", letra: "A"   },
  { keys: ["coopera pj"],                bg: "#007b5e", letra: "CPJ" },
  { keys: ["coopera"],                   bg: "#007b5e", letra: "COO" },
  { keys: ["latam"],                     bg: "#d81a36", letra: "L"   },
  { keys: ["tap miles","tap"],           bg: "#009900", letra: "TAP" },
  { keys: ["max milhas"],                bg: "#1e3a6e", letra: "MM"  },
  { keys: ["hotmilhas"],                 bg: "#cc3300", letra: "HM"  },
  { keys: ["ipiranga"],                  bg: "#f5a800", letra: "IP"  },
  { keys: ["esfera empresas"],           bg: "#8b0000", letra: "EE"  },
  { keys: ["esfera"],                    bg: "#8b0000", letra: "E_"  },
  { keys: ["bank milhas"],               bg: "#0066cc", letra: "BM"  },
  { keys: ["cash milhas"],               bg: "#5a5a5a", letra: "CM"  },
  { keys: ["curtaí","curtai"],           bg: "#e8a000", letra: "CT"  },
  { keys: ["compro suas milhas"],        bg: "#1e3a4a", letra: "CSM" },
  { keys: ["átomos","atomos"],           bg: "#000000", letra: "ÁT"  },
  { keys: ["gpa"],                       bg: "#00aa44", letra: "GPA" },
  { keys: ["pontos caixa"],              bg: "#007b5e", letra: "PC"  },
  { keys: ["caixa empresas"],            bg: "#007b5e", letra: "CE"  },
  { keys: ["sicredi empresarial"],       bg: "#009900", letra: "SCE" },
  { keys: ["sicredi"],                   bg: "#009900", letra: "SC"  },
  { keys: ["dotz"],                      bg: "#ff6600", letra: "DZ"  },
  { keys: ["porto plus"],                bg: "#0057a8", letra: "PP"  },
  { keys: ["inter loop"],                bg: "#ff6b00", letra: "IL"  },
  { keys: ["inter empresas"],            bg: "#ff6b00", letra: "IE"  },
  { keys: ["volare"],                    bg: "#c8102e", letra: "VL"  },
  { keys: ["membership rewards","amex"], bg: "#006fcf", letra: "MR"  },
  { keys: ["safra rewards"],             bg: "#003366", letra: "SR"  },
  { keys: ["suma"],                      bg: "#1e3a4a", letra: "SU"  },
  { keys: ["cressol"],                   bg: "#007b5e", letra: "CR"  },
  { keys: ["banrisul"],                  bg: "#003087", letra: "BR"  },
  { keys: ["unicred"],                   bg: "#009900", letra: "UC"  },
  { keys: ["milhas plus"],               bg: "#e8a000", letra: "M+"  },
  { keys: ["xp pontos"],                 bg: "#1a1a2e", letra: "XP"  },
  { keys: ["nubank"],                    bg: "#820ad1", letra: "NU"  },
  { keys: ["ailos"],                     bg: "#007b5e", letra: "AI"  },
  { keys: ["banestes"],                  bg: "#003087", letra: "BN"  },
  { keys: ["bb empresas"],               bg: "#f5a800", letra: "BB"  },
  { keys: ["itaú empresas","itau empresas"], bg: "#d48c0c", letra: "ITE" },
  { keys: ["pontos btg"],                bg: "#1a1a2e", letra: "BTG" },

  // ── Internacionais ──────────────────────────────────────────────────
  { keys: ["iberia"],                    bg: "#cc0000", letra: "IB"  },
  { keys: ["mileageplus","united"],      bg: "#002244", letra: "UA"  },
  { keys: ["all accor","accor"],         bg: "#c8102e", letra: "AL"  },
  { keys: ["Qantas","qantas"],           bg: "#4e0000", letra: "QT"},
  { keys: ["ihg"],                       bg: "#6a0dad", letra: "IHG" },
  { keys: ["aadvantage","american"],     bg: "#0078d2", letra: "AA"  },
  { keys: ["flying blue"],               bg: "#003087", letra: "FB"  },
  { keys: ["british airways"],           bg: "#2b4090", letra: "BA"  },
  { keys: ["qatar"],                     bg: "#5c0632", letra: "QR"  },
  { keys: ["aeroplan"],                  bg: "#c8102e", letra: "AP"  },
  { keys: ["copa","connectmiles"],       bg: "#0033a0", letra: "CM"  },
  { keys: ["delta"],                     bg: "#c8102e", letra: "DL"  },
  { keys: ["emirates"],                  bg: "#c8102e", letra: "EK"  },
  { keys: ["virgin atlantic","flying club"], bg: "#e8003d", letra: "VS" },
  { keys: ["finnair"],                   bg: "#003580", letra: "AY"  },
  { keys: ["wyndham"],                   bg: "#003087", letra: "WY"  },
];

const getLogo = (nome = "") => {
  const n = nome.toLowerCase();
  for (const l of LOGOS_MAP) {
    if (l.keys.some((k) => n.includes(k))) return l;
  }
  return { bg: "#607d8b", letra: (nome || "??").slice(0, 2).toUpperCase() };
};

const LogoCircle = ({ nome, size = 28 }) => {
  const { bg, letra } = getLogo(nome);
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      width: size, height: size, borderRadius: "50%",
      background: bg, color: "#fff",
      fontSize: size * 0.32, fontWeight: 700, flexShrink: 0,
      boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
    }}>{letra}</span>
  );
};

// ── Ícones em linha (traço fino, estilo sofisticado) ───────────────────
const svgBase = (color, size) => ({
  width: size, height: size, viewBox: "0 0 24 24", fill: "none",
  stroke: color, strokeWidth: 1.7, strokeLinecap: "round", strokeLinejoin: "round",
});
const IconPlane = ({ color, size = 20 }) => (
  <svg {...svgBase(color, size)}>
    <path d="M22 2 11 13" />
    <path d="M22 2 15 22l-4-9-9-4 20-7z" />
  </svg>
);
const IconCalendar = ({ color, size = 20 }) => (
  <svg {...svgBase(color, size)}>
    <rect x="3" y="4.5" width="18" height="16.5" rx="2.5" />
    <path d="M3 9.5h18M8 2.5v4M16 2.5v4" />
  </svg>
);
const IconWallet = ({ color, size = 20 }) => (
  <svg {...svgBase(color, size)}>
    <rect x="2.5" y="6" width="19" height="12" rx="2.6" />
    <circle cx="12" cy="12" r="2.3" />
    <path d="M6 12h.01M18 12h.01" />
  </svg>
);

// ── Leitura robusta de valores do FireDAC ──────────────────────────────
// Busca a chave sem depender de maiúscula/minúscula (total_milhas_negociadas,
// TOTAL_MILHAS_NEGOCIADAS, etc.)
const getVal = (row, nome) => {
  if (!row) return undefined;
  const alvo = nome.toLowerCase();
  for (const k of Object.keys(row)) {
    if (k.toLowerCase() === alvo) return row[k];
  }
  return undefined;
};

// Converte para número aceitando number, "10098440", "10098440.00"
// e até formato pt-BR "10.098.440,18" ou "R$ 499.780,18".
const toNumber = (v) => {
  if (v == null) return 0;
  if (typeof v === "number") return v;
  let s = String(v).trim().replace(/[R$\s]/g, "");
  if (s === "") return 0;
  if (s.includes(",") && s.includes(".")) {
    // pt-BR: ponto = milhar, vírgula = decimal
    s = s.replace(/\./g, "").replace(",", ".");
  } else if (s.includes(",")) {
    s = s.replace(",", ".");
  }
  const n = Number(s);
  return isNaN(n) ? 0 : n;
};

// ── Formatação ─────────────────────────────────────────────────────────
const fmtNum = (v) =>
  Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const fmtInt = (v) =>
  Number(v || 0).toLocaleString("pt-BR");

const fmtDate = (v) => {
  if (!v) return null;
  const s = String(v).trim();
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
  const compT = s.match(/^(\d{4})(\d{2})(\d{2})T/);
  if (compT) return `${compT[3]}/${compT[2]}/${compT[1]}`;
  const comp = s.match(/^(\d{4})(\d{2})(\d{2})$/);
  if (comp) return `${comp[3]}/${comp[2]}/${comp[1]}`;
  if (s.match(/^\d{2}\/\d{2}\/\d{4}/)) return s.slice(0, 10);
  return s;
};

export default function Dashboard({ clienteId, onCompensarClick }) {
  const [loading, setLoading]         = useState(false);
  const [cartoes, setCartoes]         = useState([]);
  const [compensas, setCompensas]     = useState([]);
  const [filtroTit, setFiltroTit]     = useState(null);
  const [filtroProg, setFiltroProg]   = useState(null);
  const [isMobile, setIsMobile]       = useState(window.innerWidth <= 768);

  // ── Novos indicadores vindos do GetPesquisaDashboard ─────────────────
  const [stats, setStats] = useState({
    totalMilhas: 0,   // total_milhas_negociadas
    milhasMes:   0,   // milhas_negociadas_mes
    economia:    0,   // valor_economia
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!clienteId) return;
    carregarTudo();
  }, [clienteId]);

  const carregarTudo = async () => {
    setLoading(true);
    try {
      // 1. Busca PesquisaTitular - isso retorna TODOS os titulares (principal + agregados)
      const titRes = await api.get("/ServerPrincipal/PesquisaTitular", { params: { Cliente: clienteId } });
      const titRows = extractRows(titRes.data);

      // PesquisaTitular já retorna todos os titulares (cliente principal + agregados)
      // Não precisamos adicionar manualmente o clienteId, pois ele já está na lista

      // Remove duplicatas pelo cli_id
      const seenTit = new Set();
      const titularesDeduplic = titRows.filter((t) => {
        const rawId = t.cli_id ?? t.CLI_ID;
        const k = rawId != null ? String(rawId) : null;
        if (!k || k === "0" || seenTit.has(k)) return false;
        seenTit.add(k);
        return true;
      });

      console.log("Titulares encontrados:", titularesDeduplic.length);
      console.log("IDs dos titulares:", titularesDeduplic.map(t => t.cli_id ?? t.CLI_ID));

      // Se não encontrou nenhum titular, tenta buscar só o principal
      let titularesParaBuscar = titularesDeduplic;
      if (titularesDeduplic.length === 0) {
        console.log("Nenhum titular encontrado, buscando apenas o principal");
        titularesParaBuscar = [{ cli_id: clienteId, cli_nome: "", cli_email: "", cli_cpf: "" }];
      }

      // 2. Busca PesquisaCartoes para CADA titular em paralelo
      const carResArr = await Promise.all(
        titularesParaBuscar.map((t) => {
          const cliId = t.cli_id ?? t.CLI_ID;
          console.log(`Buscando cartões para titular ID: ${cliId}`);
          return api.get("/ServerPrincipal/PesquisaCartoes", { params: { Cliente: cliId } })
            .then((res) => ({ rows: extractRows(res.data), tit: t }))
            .catch((err) => {
              console.error(`Erro ao buscar cartões para titular ${cliId}:`, err);
              return { rows: [], tit: t };
            });
        })
      );

      // 3. Busca indicadores do dashboard e PesquisaCompensa
      const [dashRes, compRes] = await Promise.all([
        api.get(DASHBOARD_ENDPOINT,                    { params: { Cliente: clienteId } }).catch(() => ({ data: [] })),
        api.get("/ServerPrincipal/PesquisaCompensa",   { params: { Cliente: clienteId } }).catch(() => ({ data: [] })),
      ]);

      // 3.1 Monta os 3 indicadores
      const dashRows = extractRows(dashRes.data);
      const dashRow  = dashRows[0] || {};
      console.log("[Dashboard] resposta bruta:", dashRes.data);
      console.log("[Dashboard] linhas extraídas:", dashRows);
      console.log("[Dashboard] chaves da linha:", Object.keys(dashRow));
      setStats({
        totalMilhas: toNumber(getVal(dashRow, "total_milhas_negociadas")),
        milhasMes:   toNumber(getVal(dashRow, "milhas_negociadas_mes")),
        economia:    toNumber(getVal(dashRow, "valor_economia")),
      });

      // 4. Monta lista flat de cartões sem duplicatas
      const cartoesFlat = [];
      const seenCar = new Set();

      carResArr.forEach(({ rows, tit }) => {
        console.log(`Titular ${tit.cli_nome ?? tit.CLI_Nome ?? "?"} tem ${rows.length} cartões`);

        rows.forEach((c) => {
          const carKey = String(c.car_id ?? c.CAR_ID ?? "");
          if (!carKey || seenCar.has(carKey)) return;
          seenCar.add(carKey);

          cartoesFlat.push({
            car_id:            c.car_id            ?? c.CAR_ID,
            car_nome_programa: c.car_nome_programa  ?? c.CAR_NOME_PROGRAMA ?? "",
            car_saldo_milhas:  Number(c.car_saldo_milhas   ?? c.CAR_SALDO_MILHAS  ?? 0),
            car_vunitario:     Number(c.car_vunitario      ?? c.CAR_VUNITARIO     ?? 0),
            car_qtde_cpf:      Number(c.car_qtde_cpf       ?? c.CAR_QTDE_CPF      ?? 0),
            car_qtde_expira:   Number(c.car_qtde_expira    ?? c.CAR_QTDE_EXPIRA   ?? 0),
            car_dtexpiracao:   c.car_dtexpiracao    ?? c.CAR_DTEXPIRACAO   ?? null,
            car_expira:        Number(c.car_expira         ?? c.CAR_EXPIRA        ?? 0),
            cli_id:            tit.cli_id           ?? tit.CLI_ID,
            cli_nome:          tit.cli_nome         ?? tit.CLI_NOME        ?? "",
          });
        });
      });

      console.log("Total de cartões encontrados:", cartoesFlat.length);
      console.log("Cartões por titular:", cartoesFlat.reduce((acc, c) => {
        const nome = c.cli_nome || "Sem nome";
        acc[nome] = (acc[nome] || 0) + 1;
        return acc;
      }, {}));

      setCartoes(cartoesFlat);
      setCompensas(extractRows(compRes.data));

    } catch (e) {
      console.error("Erro ao carregar dashboard:", e);
      message.error("Erro ao carregar dashboard.");
    } finally {
      setLoading(false);
    }
  };

  // ── Filtros ────────────────────────────────────────────────────────
  const titulares = [...new Set(cartoes.map((c) => c.cli_nome).filter(Boolean))];
  const progs     = [...new Set(cartoes.map((c) => c.car_nome_programa).filter(Boolean))];

  const cartoesFiltrados = cartoes.filter((c) => {
    const nome = c.cli_nome ?? "";
    const prog = c.car_nome_programa ?? "";
    return (!filtroTit || nome === filtroTit) && (!filtroProg || prog === filtroProg);
  });

  // ── Card de indicador (moderno + sofisticado) ──────────────────────
  const statCard = ({ accent, soft, Icon, label, value, isMonetary = false }) => (
    <div style={{
      background: "linear-gradient(180deg,#ffffff 0%,#fcfcfe 100%)",
      borderRadius: 18,
      padding: isMobile ? "16px 16px" : "22px 24px",
      border: "1px solid #eef0f4",
      boxShadow: "0 8px 24px rgba(15,23,42,0.06)",
    }}>
      <div style={{
        display: "flex", alignItems: "flex-start", justifyContent: "space-between",
        gap: 8, marginBottom: isMobile ? 14 : 18,
      }}>
        <span style={{
          fontSize: isMobile ? 10 : 11, color: "#94a3b8", fontWeight: 600,
          textTransform: "uppercase", letterSpacing: "0.09em", lineHeight: 1.4, maxWidth: "70%",
        }}>
          {label}
        </span>
        <span style={{
          width: isMobile ? 34 : 40, height: isMobile ? 34 : 40, borderRadius: 12,
          background: soft, border: `1px solid ${accent}22`,
          display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
        }}>
          <Icon color={accent} size={isMobile ? 17 : 20} />
        </span>
      </div>
      <div style={{
        fontSize: isMobile ? 22 : 32, fontWeight: 700, color: "#0f172a",
        letterSpacing: "-0.03em", lineHeight: 1.1, fontVariantNumeric: "tabular-nums",
      }}>
        {isMonetary ? `R$ ${fmtNum(value)}` : fmtInt(value)}
      </div>
      <div style={{
        marginTop: isMobile ? 10 : 14, height: 3, width: 34,
        borderRadius: 2, background: accent, opacity: 0.9,
      }} />
    </div>
  );

  // Barra de CPFs utilizados
  const CpfBar = ({ usado, total }) => {
    if (!total || total === 0) return <span style={{ color: "#bbb", fontSize: 12 }}>--</span>;
    const pct = Math.min(100, Math.round((usado / total) * 100));
    const cor = pct >= 80 ? "#f5222d" : pct >= 50 ? "#fa8c16" : "#52c41a";
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 60 }}>
        <div style={{ flex: 1, height: 8, borderRadius: 4, background: "#e8e8e8", overflow: "hidden" }}>
          <div style={{ width: `${pct}%`, height: "100%", background: cor, borderRadius: 4, transition: "width 0.3s" }} />
        </div>
        <span style={{ fontSize: 11, color: "#555", whiteSpace: "nowrap", fontWeight: 600 }}>
          {usado}/{total}
        </span>
      </div>
    );
  };

  const th = {
    padding: isMobile ? "6px 8px" : "10px 14px",
    fontSize: isMobile ? 10 : 12,
    fontWeight: 600,
    color: "#777", textAlign: "left", borderBottom: "1px solid #e8e8e8",
    whiteSpace: "nowrap", background: "#fafafa",
  };

  const td = (align = "left") => ({
    padding: isMobile ? "8px 8px" : "13px 14px",
    fontSize: isMobile ? 11 : 13,
    color: "#333",
    borderBottom: "1px solid #f5f5f5", textAlign: align,
    whiteSpace: "nowrap",
  });

  return (
    <Spin spinning={loading}>
      <div style={{
        padding: isMobile ? "12px 8px" : "24px 28px",
        minHeight: "100vh",
        background: "#f0f2f5"
      }}>

        {/* Título */}
        <div style={{
          fontSize: isMobile ? 20 : 24,
          fontWeight: 700,
          color: "#000000",
          marginBottom: isMobile ? 12 : 20,
          letterSpacing: "-0.3px"
        }}>
          Dashboard
        </div>

        <div style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? 16 : 20,
          alignItems: "flex-start"
        }}>
          {/* Coluna principal */}
          <div style={{ flex: 1, minWidth: 0, width: isMobile ? "100%" : "auto" }}>

            {/* Stats — faixa colorida atrás dos cards */}
            <div style={{
              background: "linear-gradient(135deg,#1e293b 0%,#0f172a 100%)",
              borderRadius: 18,
              padding: isMobile ? 10 : 16,
              marginBottom: isMobile ? 12 : 20,
              boxShadow: "0 10px 30px rgb(0, 0, 0)",
            }}>
              <div style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(3, 1fr)",
                gap: isMobile ? 8 : 14,
              }}>
                {statCard({
                  accent: "#4f46e5", soft: "#eef2ff",
                  Icon: IconPlane,
                  label: "Total Milhas Utilizadas",
                  value: stats.totalMilhas,
                })}
                {statCard({
                  accent: "#0f766e", soft: "#f0fdfa",
                  Icon: IconCalendar,
                  label: "Milhas Utilizadas (Mês Atual)",
                  value: stats.milhasMes,
                })}
                {statCard({
                  accent: "#059669", soft: "#ecfdf5",
                  Icon: IconWallet,
                  label: "Economia Geral",
                  value: stats.economia,
                  isMonetary: true,
                })}
              </div>
            </div>

            {/* Filtros */}
            <div style={{
              background: "#0e1519", borderRadius: "8px 8px 0 0",
              padding: isMobile ? "12px 12px" : "16px 20px",
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: isMobile ? 12 : 16,
            }}>
              <div style={{ flex: 1, minWidth: isMobile ? "auto" : 200, width: isMobile ? "100%" : "auto" }}>
                <div style={{
                  fontSize: isMobile ? 10 : 12,
                  color: "rgba(255,255,255,0.7)",
                  marginBottom: 4,
                  fontWeight: 500
                }}>
                  Filtrar por Titular de Conta
                </div>
                <Select
                  style={{ width: "100%" }}
                  placeholder={isMobile ? "Titular" : "Todos os titulares"}
                  allowClear onChange={setFiltroTit} value={filtroTit}
                  size={isMobile ? "small" : "middle"}
                >
                  {titulares.map((t) => <Option key={t} value={t}>{t}</Option>)}
                </Select>
              </div>
              <div style={{ flex: 1, minWidth: isMobile ? "auto" : 200, width: isMobile ? "100%" : "auto" }}>
                <div style={{
                  fontSize: isMobile ? 10 : 12,
                  color: "rgba(255,255,255,0.7)",
                  marginBottom: 4,
                  fontWeight: 500
                }}>
                  Filtrar por Programa de Fidelidade
                </div>
                <Select
                  style={{ width: "100%" }}
                  placeholder={isMobile ? "Programa" : "Todos programas"}
                  allowClear onChange={setFiltroProg} value={filtroProg}
                  optionLabelProp="label"
                  size={isMobile ? "small" : "middle"}
                >
                  {progs.map((p) => (
                    <Option key={p} value={p} label={p}>
                      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <LogoCircle nome={p} size={isMobile ? 16 : 20} />
                        <span style={{ fontSize: isMobile ? 12 : 14 }}>{p}</span>
                      </span>
                    </Option>
                  ))}
                </Select>
              </div>
            </div>

            {/* Tabela de cartões */}
            <div style={{
              background: "#fff", borderRadius: "0 0 8px 8px",
              border: "1px solid #e8e8e8", borderTop: "none",
              overflow: "auto",
              maxWidth: "100%",
            }}>
              <table style={{
                width: "100%",
                borderCollapse: "collapse",
                minWidth: isMobile ? 600 : 700,
                fontSize: isMobile ? 11 : 13,
              }}>
                <thead>
                  <tr>
                    <th style={th}>Titular</th>
                    <th style={th}>Programa</th>
                    <th style={{ ...th, textAlign: "right" }}>Saldo</th>
                    {!isMobile && <th style={{ ...th, textAlign: "right" }}>Saldo Comp.</th>}
                    <th style={{ ...th, textAlign: "right" }}>Custo Médio</th>
                    {!isMobile && <th style={th}>Próx. Lote</th>}
                    <th style={th}>CPFs</th>
                  </tr>
                </thead>
                <tbody>
                  {cartoesFiltrados.length === 0 ? (
                    <tr>
                      <td colSpan={isMobile ? 6 : 7} style={{ padding: "32px 16px", textAlign: "center", color: "#bbb", fontSize: isMobile ? 12 : 13 }}>
                        {loading ? "Carregando..." : "Nenhum dado encontrado"}
                      </td>
                    </tr>
                  ) : (
                    cartoesFiltrados.map((c, i) => {
                      const nomeCompleto = c.cli_nome ?? "";
                      const nome      = nomeCompleto ? nomeCompleto.split(" ")[0] : "—";
                      const prog      = c.car_nome_programa ?? "—";
                      const saldo     = Number(c.car_saldo_milhas ?? 0);
                      const custo     = Number(c.car_vunitario ?? 0);
                      const qtdeExp   = Number(c.car_qtde_expira ?? 0);
                      const dataExp   = fmtDate(c.car_dtexpiracao ?? "");
                      const expira    = Number(c.car_expira ?? 0);
                      const qtdeCpf   = Number(c.car_qtde_cpf ?? 0);
                      const cpfUsado  = 0;

                      const proxLote = expira === 1 && qtdeExp > 0 && dataExp
                        ? `${fmtInt(qtdeExp)} em ${dataExp}`
                        : "---";

                      return (
                        <tr key={c.car_id ?? i}
                          style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                          <td style={td()}>
                            <span style={{ fontWeight: 500, color: "#222", fontSize: isMobile ? 11 : 13 }}>
                              {isMobile ? nome.substring(0, 10) : nome}
                            </span>
                          </td>
                          <td style={td()}>
                            <span style={{ display: "flex", alignItems: "center", gap: isMobile ? 4 : 8 }}>
                              <LogoCircle nome={prog} size={isMobile ? 18 : 24} />
                              <span style={{ fontSize: isMobile ? 11 : 13 }}>
                                {isMobile ? prog.substring(0, 12) : prog}
                              </span>
                            </span>
                          </td>
                          <td style={{ ...td("right"), fontWeight: 600, color: saldo > 0 ? "#222" : "#bbb", fontSize: isMobile ? 11 : 13 }}>
                            {saldo > 0 ? fmtInt(saldo) : "---"}
                          </td>
                          {!isMobile && (
                            <td style={{ ...td("right"), color: "#bbb" }}>---</td>
                          )}
                          <td style={{ ...td("right"), color: custo > 0 ? "#333" : "#bbb", fontSize: isMobile ? 11 : 13 }}>
                            {custo > 0 ? `R$ ${fmtNum(custo)}` : "---"}
                          </td>
                          {!isMobile && (
                            <td style={{ ...td(), color: proxLote === "---" ? "#bbb" : "#333", fontSize: isMobile ? 11 : 13 }}>
                              {proxLote}
                            </td>
                          )}
                          <td style={td()}>
                            <CpfBar usado={cpfUsado} total={qtdeCpf} />
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Coluna lateral */}
          {!isMobile && (
            <div style={{ width: 260, flexShrink: 0, display: "flex", flexDirection: "column", gap: 12 }}>

              {/* Pendências da Semana — Compensações */}
              <div style={{
                background: "linear-gradient(180deg,#ffffff 0%,#fcfcfe 100%)",
                borderRadius: 18, padding: "18px",
                border: "1px solid #eef0f4",
                boxShadow: "0 8px 24px rgba(15,23,42,0.06)",
                maxHeight: 460, display: "flex", flexDirection: "column",
              }}>
                <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 14, color: "#0f172a" }}>
                  Pendências da Semana
                </div>

                {compensas.length === 0 ? (
                  <div style={{ fontSize: 13, color: "#94a3b8", textAlign: "center", padding: "8px 0 4px" }}>
                    Não há pendências!
                  </div>
                ) : (
                  <div style={{ overflowY: "auto", flex: 1, marginBottom: 12 }}>
                    {compensas.map((c, i) => {
                      const nome     = c.cli_nome          ?? c.CLI_NOME          ?? "";
                      const prog     = c.car_nome_programa ?? c.CAR_NOME_PROGRAMA ?? "";
                      const pontos   = Number(c.clu_pontos       ?? c.CLU_PONTOS       ?? 0);
                      const mensal   = Number(c.clu_vmensalidade ?? c.CLU_VMENSALIDADE ?? 0);
                      const venc     = fmtDate(c.clu_vencimento  ?? c.CLU_VENCIMENTO   ?? "");

                      let vencido = false;
                      try { vencido = c.clu_vencimento && new Date(c.clu_vencimento) < new Date(); } catch {}

                      return (
                        <div key={c.clu_id ?? i} style={{
                          background: "#f8fafc",
                          borderRadius: 10, padding: "10px 12px",
                          marginBottom: 8, borderLeft: `3px solid ${vencido ? "#ef4444" : "#f59e0b"}`,
                        }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
                            <LogoCircle nome={prog} size={18} />
                            <span style={{ fontSize: 12, fontWeight: 700, color: "#0f172a" }}>
                              {nome.split(" ")[0]} — {prog}
                            </span>
                          </div>
                          <div style={{ fontSize: 11, color: "#64748b", lineHeight: 1.6 }}>
                            <div>{fmtInt(pontos)} pontos</div>
                            <div>R$ {fmtNum(mensal)}/mês</div>
                            {venc && (
                              <div style={{ color: vencido ? "#dc2626" : "#94a3b8" }}>
                                Venc: {venc}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                <button
                  onClick={() => onCompensarClick && onCompensarClick()}
                  style={{
                    width: "100%", background: "#fff",
                    border: "1px solid #e2e8f0", color: "#475569",
                    borderRadius: 8, padding: "8px 0", fontSize: 11,
                    fontWeight: 700, cursor: "pointer", letterSpacing: "0.05em",
                  }}>
                  OUTRAS PENDÊNCIAS
                </button>
              </div>

            </div>
          )}
        </div>

        {/* Versão mobile da coluna lateral */}
        {isMobile && (
          <div style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            marginTop: 16
          }}>

            {/* Pendências da Semana — Compensações */}
            <div style={{
              background: "linear-gradient(180deg,#ffffff 0%,#fcfcfe 100%)",
              borderRadius: 18, padding: "18px",
              border: "1px solid #eef0f4",
              boxShadow: "0 8px 24px rgba(15,23,42,0.06)",
              display: "flex", flexDirection: "column",
            }}>
              <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 14, color: "#0f172a" }}>
                Pendências da Semana
              </div>

              {compensas.length === 0 ? (
                <div style={{ fontSize: 13, color: "#94a3b8", textAlign: "center", padding: "8px 0 4px" }}>
                  Não há pendências!
                </div>
              ) : (
                <div style={{ overflowY: "auto", marginBottom: 12, maxHeight: 300 }}>
                  {compensas.map((c, i) => {
                    const nome     = c.cli_nome          ?? c.CLI_NOME          ?? "";
                    const prog     = c.car_nome_programa ?? c.CAR_NOME_PROGRAMA ?? "";
                    const pontos   = Number(c.clu_pontos       ?? c.CLU_PONTOS       ?? 0);
                    const mensal   = Number(c.clu_vmensalidade ?? c.CLU_VMENSALIDADE ?? 0);
                    const venc     = fmtDate(c.clu_vencimento  ?? c.CLU_VENCIMENTO   ?? "");

                    let vencido = false;
                    try { vencido = c.clu_vencimento && new Date(c.clu_vencimento) < new Date(); } catch {}

                    return (
                      <div key={c.clu_id ?? i} style={{
                        background: "#f8fafc",
                        borderRadius: 10, padding: "10px 12px",
                        marginBottom: 8, borderLeft: `3px solid ${vencido ? "#ef4444" : "#f59e0b"}`,
                      }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 4 }}>
                          <LogoCircle nome={prog} size={18} />
                          <span style={{ fontSize: 12, fontWeight: 700, color: "#0f172a" }}>
                            {nome.split(" ")[0]} — {prog}
                          </span>
                        </div>
                        <div style={{ fontSize: 11, color: "#64748b", lineHeight: 1.6 }}>
                          <div>{fmtInt(pontos)} pontos</div>
                          <div>R$ {fmtNum(mensal)}/mês</div>
                          {venc && (
                            <div style={{ color: vencido ? "#dc2626" : "#94a3b8" }}>
                              Venc: {venc}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}

              <button
                onClick={() => onCompensarClick && onCompensarClick()}
                style={{
                  width: "100%", background: "#fff",
                  border: "1px solid #e2e8f0", color: "#475569",
                  borderRadius: 8, padding: "8px 0", fontSize: 11,
                  fontWeight: 700, cursor: "pointer", letterSpacing: "0.05em",
                }}>
                OUTRAS PENDÊNCIAS
              </button>
            </div>

          </div>
        )}
      </div>
    </Spin>
  );
}